/**
 * IMPORTS
 */
function handleLabelTipoEntrega(tipo: number | null | undefined) {
  if (typeof tipo !== "number" || !Number.isFinite(tipo)) {
    return "";
  }

  switch (tipo) {
    case 1:
      return "balcao";
    case 2:
      return "correios";
    case 3:
      return "motoboy_letscom";
    case 4:
      return "outros";
    default:
      return "";
  }
}

/**
 * EXPORTS
 */
export { handleLabelTipoEntrega };
